export class OmegaCustomerDetails {
    public customerNumberId: number;
    public legendType1: any;
    public legendType2: any;
    public legendType3: any;
}
